import { render, staticRenderFns } from "./SalesViewCombo.vue?vue&type=template&id=37b7e1ec&scoped=true&"
import script from "./SalesViewCombo.vue?vue&type=script&lang=js&"
export * from "./SalesViewCombo.vue?vue&type=script&lang=js&"
import style0 from "./SalesViewCombo.vue?vue&type=style&index=0&id=37b7e1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7e1ec",
  null
  
)

export default component.exports